// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { Row,Col,Icon,Upload,Button,Dialog,Loading,MessageBox, Message,Notification } from 'element-ui';
import './scss/base.scss'
import skyRequest from 'skytech-request'
import skyUpload from 'sky-upload'
import OSS from 'ali-oss'
import { init as domainInit, getRequestUse, getDomain } from 'sky-domain'

domainInit("mobileUpload", process.env.NODE_ENV)
window.getRequestUse = getRequestUse
window.getDomain = getDomain

Vue.use(Upload);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Row);
Vue.use(Col);
Vue.use(Icon);
Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.use(skyUpload, {
  request: skyRequest,
  OSS,
  getHost: window.getDomain
})
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js